<template>
  <div class="login">
    <h1 class="section-title">
      {{ $t("Password reset") }}
    </h1>
    <van-form @submit="onSubmit">
      <van-field
        v-model="password"
        type="password"
        :name="$t('password')"
        :label="$t('password')"
        :placeholder="$t('password')"
        :rules="[{ required: true, message: $t('password is required') }]"
      />
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          {{ $t("reset password") }}
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
export default {
  name: "PasswordReset",
  data() {
    return {
      password: ""
    };
  },
  methods: {
    ...mapActions("account", ["passwordReset"]),
    ...mapMutations("setting", ["SET_PAGE_TITLE"]),
    onSubmit() {
      const { password } = this;
      const { uid, token } = this.$route.query;
      if (password && uid && token) {
        this.passwordReset({
          uid,
          token,
          new_password1: password,
          new_password2: password
        }).then(() => {
          this.$router.push({ name: "login" });
        });
      } else {
        this.$notify({
          type: "error",
          group: "alert",
          title: this.$t("error"),
          text: this.$t("Password Reset error")
        });
      }
    }
  },
  created() {
    this.SET_PAGE_TITLE(this.$t("Password reset"));
  }
};
</script>
